<template>
    <dx-grid
        :url="url"
        :columns="columns"
        :title="title"
        :onLoaded="onLoaded"
        :beforeSetupGrid="beforeSetupGrid"
    ></dx-grid>
</template>

<script>
import moment from "moment";

export default {
    data: () => ({
        title: "Student Class Info",
        url: "",
        userBranch: "",

        columns: [
            {
                label: "Play",
                field: "play",
                template: "play-button-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Eng Name",
                field: "engName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Heb Name",
                field: "hebName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student ID",
                field: "studentID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Account ID",
                field: "familyID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Father Name",
                field: "firstName",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Father Name Hebrew",
                field: "firstNameH",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name",
                field: "lastName",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name Hebrew",
                field: "lastNameH",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Grand Parent 1",
                field: "grandParent1",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Grand Parent 2",
                field: "grandParent2",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Phone",
                field: "homePhone",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cell Phone",
                field: "cellPhone",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address1",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Class",
                field: "class",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Section",
                field: "section",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Building",
                field: "building",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Skip Card",
                field: "skipCard",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "DOB",
                field: "dob",
                type: "date",
                format: "MM/dd/yyyy",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Registered",
                field: "isRegistered",
                type: "boolean",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Missing Requirements",
                field: "missingFamilyRequirements",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "tuitionBalance",
                label: "Tuition Balance",
                type: "number",
                format: "currency",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch Recording",
                template: "link-audio-cell-template",
                field: "branchRecordingFile",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher1 Recording",
                template: "link-audio-cell-template",
                field: "teacherNameRecording",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher2 Recording",
                template: "link-audio-cell-template",
                field: "teacherNameRecording2",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "List Type",
                field: "listType",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Class Announcement",
                field: "classAnnouncement",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Is Public",
                field: "isPublic",
                type: "boolean",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Public Date",
                field: "publicDate",
                type: "date",
                format: "MM/dd/yyyy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {
        this.columns.find((c) => c.field == "play").action = this.playClassInfo;
    },
    methods: {
        beforeSetupGrid() {
            this.userBranch = this.$store.state.authentication.branch;

            this.url =
                "studentsClassInfo?" +
                (this.userBranch != "null" ? "branch=" + this.userBranch : "");
        },
        // async onRowClicked(row) {
        //     this.$router.push({
        //         name: "Account View",
        //         params: {
        //             id: row.utaId,
        //         },
        //     });
        // },
        onLoaded(data) {
            if (!data.length) return;

            data.forEach((d) => (d.playIcon = "mdi-play-circle"));
        },
        playClassInfo(row) {
            if (!row.audio) {
                row.audio = new Audio(
                    "http://uta-plivo.azurewebsites.net/api/ivr/getClassInfo?accountID=" +
                        row.familyID +
                        "&studentID=" +
                        row.studentID,
                );
            }

            if (row.audio.paused) {
                row.audio.play();
                row.playIcon = "mdi-pause-circle";
            } else {
                row.audio.pause();

                row.playIcon = "mdi-play-circle";
            }
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
</style>
